// src/pages/Section21_1.js
import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';
import apiService from '../../config';
import { useLanguage } from "../../StoreContext/LanguageContext";

const RailwaySection21_1 = ({ setSubComponent }) => {
  const { language, translations } = useLanguage();
  const [showPreview, setShowPreview] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [loadingRecords, setLoadingRecords] = useState(false);
  const [defaultMainContent, setDefaultMainContent] = useState('');
  const [proposalData, setProposalData] = useState({});

  // Editable form data
  const [formData, setFormData] = useState({
    caseNumber: "",
    village: "",
    taluka: "",
    district: "",
    fileNumber: "",
    section_21_1_date: "",
    area: "",
    section_21_1_notification: "",
    lastDate: "",
    landOwners: [],
    header: "",
    officename: "",
    branchname: "",
    sectioncontent: "",
    email: "",
    contactNo: "",
    section_21_1_submission_date: ""
  });

  const [loadingusersLAO, setLoadingusersLAO] = useState(false);
  const [usersLAO, setusersLAO] = useState([]);
  const laoName = usersLAO?.[0]?.full_name || 'N/A';
  const laoDesi = usersLAO?.[0]?.designation || 'N/A';

  const ROLES = {
    COLLECTOR: 1,
    LAO: 3,
    SAMANVAY: 6,
    PROJECT_INCHARGE: 18,
    DATA_ENTRY: 14
  };

  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

  // Fetch projectId
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name
          };
        } catch (e) {
          console.error('Error parsing current project data (currentProjectData):', e);
        }
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setCurrentProjectId(projectInfo.id);
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Fetch proposalId
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');
      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          };
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setCurrentProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);

  // Fetch data from API when projectId and proposalId are available
  useEffect(() => {
    fetchData();
    fetchusersLAO();
  }, [currentProjectId, currentProposalId]);

  const fetchData = async () => {
    if (!currentProjectId || !currentProposalId) return;

    try {
      // setLoading(true);
      setLoadingRecords(true);
      const response = await apiService.getProposalById(currentProjectId, currentProposalId);

      const ownerResponse = await apiService.get("getAllOwner", {
        projectId: currentProjectId,
        proposalId: currentProposalId,
        isActive: 1
      });

      setProposalData(response.data);
      const proposalData = response.data;
      const landData = ownerResponse.landAcquisition;

      // Default main content if not present in API
      const content = `यादवारे नोटीस देण्यात येते की, भूसंपादन प्रकरण ${proposalData.section_11_bhusampadan_no} नुसार मौजे ${proposalData.village_name} या गावामध्ये सोबतच्या यादीमध्ये नमुद असलेली तसेच अलीकडे चिन्हांकित केलेली व मोजलेली सुमारे ${proposalData.acquired_area || ""} भूमी, तिच्यावर  कोणत्याही इमारती बांधकाम व झाडे असल्यास त्यासह समुचित शासन म्हणून जिल्हाधिकारी बुलढाणा यांनी काढलेले आदेश क्र. ${proposalData.section_21_1_notification || ""} नुसार ${proposalData.aquired_area || ""} साठी संपादीत करुन शासना‌द्वारे ताब्यात घेण्याचे ठरविले आहे.

यादवारे या भूमीत हितसंबंधित असलेल्या सर्व व्यकर्तीना भूमीमधील त्यांच्या हितसंबंधाचे स्वरुप आणि त्यासंबंधित व्यक्तींना नुकसान भरपाईचे आणि पुनर्वसनाचे व पुनर्वसाहतीचे दावे सांगितल्या जाणाऱ्या दाव्याची रक्कम व तपशिल आणि अधिनियमाच्या कलम 20 नुसार त्यांचे कोणतेही आक्षेप असल्यास ते या बाबत निवेदन करण्यासाठी ${formData.section_21_1_representative_address || proposalData.section_21_1_representative_address} येथे दिनांक ${proposalData.section_21_1_submission_date} पर्यंत व्यक्तीशः किंवा आपल्या अभिकर्त्याद्वारा पुराव्यासह उपस्थित होण्यास फर्मविण्यात येत आहे.
          

सहपत्रः- संपादन क्षेत्राची यादी`;


      setDefaultMainContent(content);

      let counter = 1;

      setFormData({
        email: proposalData.section_11_email || "",
        contactNo: proposalData.section_11_mobile_no || "",
        caseNumber: proposalData.acquisition_proposal_no || "05/2022-23 ",
        village: proposalData.village_name || "कवठळ",
        taluka: proposalData.taluka_name || "संग्रामपूर",
        district: proposalData.dist_name || "बुलढाणा",
        fileNumber: proposalData.section_21_1_bhusampadan_no || proposalData.section_11_bhusampadan_no || "जा.क्र.काव्हि/स.म.अ./उपजि.भू.सं.(इ.व.द.)/95/2025",
        sectioncontent: proposalData.section_21_1_content || content,
        header: proposalData.section_21_1_header || "उपजिल्हाधिकारी भूसंपादन (इ.व.द.), जिल्हाधिकारी कार्यालय, बुलढाणा यांचे मार्फत कलम 21(1) नुसार काढलेली जाहिर नोटीस",
        officename: proposalData.section_21_1_office_name || proposalData.section_11_office_name || "उपजिल्हाधिकारी भूसंपादन (इमारत व दळणवळण)",
        branchname: proposalData.section_21_1_branch_name || proposalData.section_11_branch_name || "जिल्हाधिकारी कार्यालय, बुलढाणा",
        section_21_1_date: proposalData.section_21_1_date ? new Date(proposalData.section_21_1_date).toISOString().split("T")[0] : "",
        area: proposalData.total_area || "",
        acquired_area: proposalData.acquired_area || "",
        section_21_1_notification: proposalData.section_21_1_notification || proposalData.section_19_notification || "",
        lastDate: proposalData.section_21_1_date ? new Date(proposalData.section_21_1_date).toLocaleDateString('en-GB').replace(/\//g, '/') : "",
        section_21_1_representative_address: proposalData.section_21_1_representative_address,
        section_21_1_submission_date: proposalData.section_21_1_submission_date
          ? new Date(proposalData.section_21_1_submission_date).toISOString().split("T")[0]
          : "",

        landOwners: landData.flatMap((land, landIndex) =>
          (land.owners || []).map((owner, ownerIndex) => ({
            serialNo: counter++,
            groupNo: land.survey_no || land.landacid || "",
            ownerName: owner.owner_name || land.landholder_name || "",
            areaHectare: (parseFloat(owner.owner_irrigable_area) || 0).toFixed(2),
            poHectare: (parseFloat(owner.owner_non_irrigable_area) || 0).toFixed(2),
            totalHectare: (
              (parseFloat(owner.owner_irrigable_area) || 0) +
              (parseFloat(owner.owner_non_irrigable_area) || 0)
            ).toFixed(2)

          }))
        )

      });
    } catch (err) {
      setError('Failed to fetch data: ' + err.message);
    } finally {
      setLoadingRecords(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // fetch LAO users
  const fetchusersLAO = async () => {
    const role = 3;
    // setLoadingusersLAO(true);
    try {
      const response = await apiService.getAssignLAO(role, currentProjectId, currentProposalId);
      console.log('LAO users:', response);
      if (response.status === 200 && response.data) {
        setusersLAO(Array.isArray(response.data) ? response.data : []);
      } else {
        setusersLAO([]);
      }
    } catch (error) {
      console.error('Error fetching LAO users:', error);
      setusersLAO([]);
    } finally {
      setLoadingusersLAO(false);
    }
  };

  const handleInputChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      // Called as handleInputChange("fieldName", value)
      const name = eOrName;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      // Called directly from onChange={handleInputChange}
      const { name, value } = eOrName.target;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Auto-update sectioncontent when representative address or submission date changes
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      sectioncontent: `यादवारे नोटीस देण्यात येते की, भूसंपादन प्रकरण ${prev.caseNumber} नुसार मौजे ${prev.village} या गावामध्ये सोबतच्या यादीमध्ये नमुद असलेली तसेच अलीकडे चिन्हांकित केलेली व मोजलेली सुमारे ${prev.area} भूमी, तीच्यावर कोणत्याही इमारती बांधकाम व झाडे असल्यास त्यासह समुचित शासन म्हणून जिल्हाधिकारी बुलढाणा यांनी काढलेले आदेश क्र. ${prev.section_21_1_notification || ""} नुसार ${prev.area} साठी संपादीत करुन शासना‌द्वारे ताब्यात घेण्याचे ठरविले आहे.

यादवारे या भूमीत हितसंबंधित असलेल्या सर्व व्यकर्तीना भूमीमधील त्यांच्या हितसंबंधाचे स्वरुप आणि त्यासंबंधित व्यक्तींना नुकसान भरपाईचे आणि पुनर्वसनाचे व पुनर्वसाहतीचे दावे सांगितल्या जाणाऱ्या दाव्याची रक्कम व तपशिल आणि अधिनियमाच्या कलम 20 नुसार त्यांचे कोणतेही आक्षेप असल्यास ते या बाबत निवेदन करण्यासाठी ${prev.section_21_1_representative_address || ""} येथे दिनांक ${prev.section_21_1_submission_date ? new Date(prev.section_21_1_submission_date).toLocaleDateString('en-GB') : ""} पर्यंत व्यक्तीशः किंवा आपल्या अभिकर्त्याद्वारा पुराव्यासह उपस्थित होण्यास फर्मविण्यात येत आहे.

सहपत्रः- संपादन क्षेत्राची यादी`
    }));
  }, [formData.section_21_1_representative_address, formData.section_21_1_submission_date]);



  const handleLandOwnerChange = (index, field, value) => {
    const newLandOwners = [...formData.landOwners];
    newLandOwners[index] = {
      ...newLandOwners[index],
      [field]: value
    };
    setFormData(prev => ({
      ...prev,
      landOwners: newLandOwners
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {

      const updateData = {
        section_21_1_bhusampadan_no: formData.fileNumber,
        section_21_1_content: formData.sectioncontent,
        section_21_1_branch_name: formData.branchname,
        section_21_1_office_name: formData.officename,
        section_21_1_header: formData.header,
        section_21_1_date: (formData.section_21_1_date),
        section_21_1_notification: formData.section_21_1_notification,
        section_21_1_submission_date: (formData.section_21_1_submission_date),
        section_21_1_representative_address: formData.section_21_1_representative_address,
      };

      await apiService.updateProposalPublish(currentProposalId, updateData);
      alert('Data updated successfully');
      setShowEditModal(false);
      fetchData();
      setIsEditing(false);
    } catch (err) {
      setError('Failed to update data: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    setShowPreview(true);
    setTimeout(() => {
      window.print();
      setShowPreview(false);
    }, 100);
  };

  const handleSection21_1 = () => {
    console.log("Switching to Section21_1");
    setSubComponent('Section21_1');
  };

  const handleSection21_1_4 = () => {
    console.log("Switching to Section21_1_4");
    setSubComponent('Section21_1_4');
  };

  const handleUnderSection21 = () => {
    console.log("Switching to UnderSection21");
    setSubComponent('UnderSection21');
  };


  // Enhanced Edit Modal Component - Replace the existing renderEditModal function
  const renderEditModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">{translations[language].edit} {translations[language].section21_1}</h2>
            <button
              onClick={() => setShowEditModal(false)}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>

          </div>

          <form onSubmit={handleSubmit}>
            {/* Document Header Details */}
            <div className="mb-6">
              {/* <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">Document Header Details</h2>
                </div>
              </div> */}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    जाहिरनामा शीर्षक (Notice Header):
                  </label>
                  <textarea
                    name="header"
                    value={formData.header}
                    onChange={(e) => handleInputChange('header', e.target.value)}
                    rows={3}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter notice header..."
                  />
                </div> */}

                {/* <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    फाइल नंबर (File Number):
                  </label>
                  <input
                    type="text"
                    name="fileNumber"
                    value={formData.fileNumber}
                    onChange={(e) => handleInputChange('fileNumber', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter file number..."
                  />
                </div> */}
                {/* 
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    कार्यालयाचे नाव (Office Name):
                  </label>
                  <input
                    type="text"
                    name="officename"
                    value={formData.officename}
                    onChange={(e) => handleInputChange('officename', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter office name..."
                  />
                </div> */}

                {/* <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    शाखेचे नाव (Branch Name):
                  </label>
                  <input
                    type="text"
                    name="branchname"
                    value={formData.branchname}
                    onChange={(e) => handleInputChange('branchname', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter branch name..."
                  />
                </div>
              </div> */}
              </div>

              {/* Proposal Details */}
              <div className="mb-6">
                <div className="flex items-center justify-center mb-6">
                  <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                    <h2 className="font-bold text-lg">Proposal Details</h2>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="group">
                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                      प्रकरण क्रमांक (Case Number):
                    </label>
                    <input
                      type="text"
                      name="caseNumber"
                      value={formData.caseNumber}
                      onChange={(e) => handleInputChange('caseNumber', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                      placeholder="Enter case number..."
                    />
                  </div>

                  {/* <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    गाव (Village):
                  </label>
                  <input
                    type="text"
                    name="village"
                    value={formData.village}
                    onChange={(e) => handleInputChange('village', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter village name..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    तालुका (Taluka):
                  </label>
                  <input
                    type="text"
                    name="taluka"
                    value={formData.taluka}
                    onChange={(e) => handleInputChange('taluka', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter taluka name..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    जिल्हा (District):
                  </label>
                  <input
                    type="text"
                    name="district"
                    value={formData.district}
                    onChange={(e) => handleInputChange('district', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter district name..."
                  />
                </div> */}

                  <div className="group">
                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                      दिनांक (Date):
                    </label>
                    <input
                      type="date"
                      name="section_21_1_date"
                      value={formData.section_21_1_date || ""}
                      onChange={(e) => handleInputChange('section_21_1_date', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    />
                  </div>

                  {/* <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    क्षेत्र (Area):
                  </label>
                  <input
                    type="text"
                    name="area"
                    value={formData.area}
                    onChange={(e) => handleInputChange('area', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter area..."
                  />
                </div> */}

                  <div className="group">
                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                      कार्यविवरण क्रमांक :
                    </label>
                    <input
                      type="text"
                      name="section_21_1_notification"
                      value={formData.section_21_1_notification}
                      onChange={(e) => handleInputChange('section_21_1_notification', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                      placeholder="Enter order number..."
                    />
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                      दावा दाखल करण्याचे ठिकाण :
                    </label>
                    <input
                      type="text"
                      name="section_21_1_representative_address"
                      value={formData.section_21_1_representative_address}
                      onChange={(e) => handleInputChange('section_21_1_representative_address', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                      placeholder="निवेदन करण्यासाठी..."
                    />
                  </div>

                  <div className="group">
                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                      दावा दाखल करण्याची तारीख :
                    </label>
                    <input
                      type="date"
                      name="section_21_1_submission_date"
                      value={formData.section_21_1_submission_date || ""}
                      onChange={(e) => handleInputChange("section_21_1_submission_date", e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
              </div>

              {/* Main Content */}
              <div className="mb-6">
                <div className="flex items-center justify-center mb-6">
                  <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                    <h2 className="font-bold text-lg">Main Content</h2>
                  </div>
                </div>

                <textarea
                  name="sectioncontent"
                  value={
                    formData.sectioncontent
                      ? formData.sectioncontent.replace(
                        /काढलेले\s+नुसार/,
                        `काढलेले ${formData.section_21_1_notification || ""} नुसार`
                      )
                      : defaultMainContent
                  }
                  onChange={(e) => handleInputChange('sectioncontent', e.target.value)}
                  rows={12}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter main notice content..."
                />

              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4 pt-6 border-t border-gray-200">
                <button
                  type="button"
                  onClick={() => setShowEditModal(false)}
                  className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 transform hover:scale-105"
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={loading}
                  className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg"
                >
                  {loading && (
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                  )}
                  <span>{loading ? 'Saving...' : translations[language].saveChanges}</span>
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  );

  // Update the modal trigger in the return statement
  {/* Replace the existing Edit Modal section with this: */ }
  {/* Enhanced Edit Modal */ }
  { showEditModal && renderEditModal() }

  const DocumentContent = ({ isEditable = false }) => (
    <div className={showPreview ? 'print-content' : ''}>

      {/* Header */}
      <div className="text-center mb-5 mt-5">
        {/* Logo */}
        <img
          src="/Emblem_of_India.svg"
          alt="महाराष्ट्र शासन"
          className="mx-auto mb-2 w-20"
        />

        {/* Government name */}
        <div className="font-bold text-base">महाराष्ट्र शासन</div>
        <div className="font-bold text-base">महसूल व वन विभाग</div>

        {/* Office Name */}
        <div className="font-bold text-2xl font-semibold">
          {formData.officename}
        </div>

        {/* Branch */}
        <div className="font-medium text-sm font-semibold">
          शाखा :- {formData.branchname}
        </div>

        {/* Address */}
        <div className="text-sm font-semibold">
          {formData.address}
        </div>

      </div>

      {/* Bottom Contact Section */}
      <div className="text-xs mt-4">
        {/* First row: Email + Kramank */}
        <div className="flex justify-between">
          <div>
            ई-मेल :- <span className="font-bold text-black-700"> {formData.email} </span>
          </div>
          <div>
            दूरध्वनी क्रमांक :-  {formData.contactNo}
          </div>
        </div>

        {/* Horizontal line */}
        <hr className="border-black border-2 my-1" />

        {/* Second row: Reference no + Date */}
        <div className="flex justify-between">
          <div>
            {formData.section_21_1_notification}
          </div>
          <div>
            दिनांक :-  {formatDate(formData.section_21_1_date)}
          </div>
        </div>
      </div>

      {/* Page 1 */}
      <div className="page bg-white p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-sm font-bold mb-6 underline decoration-2">भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 चे कलम 21(1) नुसार जाहीर नोटीस</h1>
        </div>

        {/* Main Content - Now Editable */}
        <div className="text-justify leading-relaxed space-y-4">
          {isEditable ? (
            <textarea
              defaultValue={formData.sectioncontent}
              onBlur={(e) => handleInputChange('sectioncontent', e.target.value)}
              className="w-full h-96 p-4 border-2 border-gray-300 rounded-md resize-y bg-transparent text-justify leading-relaxed"
              placeholder="Enter main content here..."
              style={{ fontFamily: 'inherit', fontSize: 'inherit', lineHeight: 'inherit' }}
            />
          ) : (
            <div className="whitespace-pre-wrap">
              {formData.sectioncontent.includes(formData.section_21_1_notification)
                ? formData.sectioncontent
                : formData.sectioncontent.replace(
                  /काढलेले\s+नुसार/,
                  `काढलेले ${formData.section_21_1_notification || ""} नुसार`
                )
              }
              <div className="mt-12">
                {/* <div className="text-left mb-4">
            <p>(अजिंक्य गोडगे)</p>
          </div> */}

                <div className="flex items-end">
                  <div className="ml-auto text-right">
                    <p>({laoName || ''})</p>
                    <p className="mb-2">{laoDesi || ''}</p>
                    {/* <p>(इमारत व दळणवळण)</p> */}
                  </div>
                </div>
              </div>
            </div>

          )}
        </div>
      </div>

      {/* Page 2 */}
      <div className="page bg-white p-8">
        <div className="text-center p-2 space-y-1">
          {/* Line 1: Case Number */}
          <p className="font-semibold">
            भूसंपादन प्रकरण क्रमांक{" "}
            {isEditable ? (
              <input
                type="text"
                defaultValue={proposalData?.section_11_bhusampadan_no || formData.caseNumber}
                onBlur={(e) => handleInputChange('caseNumber', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-32"
              />
            ) : (
              proposalData?.section_11_bhusampadan_no || formData.caseNumber
            )}
          </p>

          {/* Line 2: Village + Taluka + District */}
          <p className="font-semibold">
            मौजे{" "}
            {isEditable ? (
              <input
                type="text"
                defaultValue={formData.village}
                onBlur={(e) => handleInputChange('village', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-16 mx-1"
              />
            ) : (
              formData.village
            )}{" "}|
            ता.{" "}
            {isEditable ? (
              <input
                type="text"
                defaultValue={formData.taluka}
                onBlur={(e) => handleInputChange('taluka', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-20 mx-1"
              />
            ) : (
              formData.taluka
            )}{" "}|
            जि.{" "}
            {isEditable ? (
              <input
                type="text"
                defaultValue={formData.district}
                onBlur={(e) => handleInputChange('district', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-20 mx-1"
              />
            ) : (
              formData.district
            )}
          </p>
        </div>


        <div className="text-center mb-8">
          <p className="font-semibold">संपादन क्षेत्राची यादी</p>
        </div>

        {/* <div className="border-2 border-black mb-8"> */}
        {/* <div className="text-center bg-gray-100 p-2">
            <p className=" font-semibold">भूसंपादन प्रकरण क्रमांक {isEditable ? (
              <input
                type="text"
                defaultValue={proposalData?.section_11_bhusampadan_no || formData.caseNumber}
                onBlur={(e) => handleInputChange('caseNumber', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-32"
              />
            ) : proposalData?.section_11_bhusampadan_no || formData.caseNumber} मौजे {isEditable ? (
              <input
                type="text"
                defaultValue={formData.village}
                onBlur={(e) => handleInputChange('village', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-16"
              />
            ) : formData.village} ता. {isEditable ? (
              <input
                type="text"
                defaultValue={formData.taluka}
                onBlur={(e) => handleInputChange('taluka', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-20"
              />
            ) : formData.taluka} जि. {isEditable ? (
              <input
                type="text"
                defaultValue={formData.district}
                onBlur={(e) => handleInputChange('district', e.target.value)}
                className="inline-block border-b border-red-600 bg-transparent text-center min-w-20"
              />
            ) : formData.district}</p>
          </div> */}

        <div className="print-table-container mb-8">

          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-black p-2 w-12">अ.क्र</th>
                <th className="border border-black p-2 w-20">गट नं.</th>
                <th className="border border-black p-2">भूधारकाचे नाव</th>
                <th className="border border-black p-2 w-24">लागवड योग्य क्षेत्र (हे.आर)</th>
                <th className="border border-black p-2 w-24">पो.ख. क्षेत्र (हे.आर)</th>
                <th className="border border-black p-2 w-24">एकूण क्षेत्र (हे.आर)</th>
              </tr>
            </thead>

            <tbody>
              {formData.landOwners.map((owner, index) => (
                <tr key={index}>
                  <td className="border border-black p-1 text-center">{owner.serialNo}</td>
                  <td className="border border-black p-1 text-center">{owner.groupNo}</td>
                  <td className="border border-black p-1 text-center">{owner.ownerName}</td>
                  <td className="border border-black p-1 text-center">{parseFloat(owner.areaHectare || 0).toFixed(2)}</td>
                  <td className="border border-black p-1 text-center">{parseFloat(owner.poHectare || 0).toFixed(2)}</td>
                  <td className="border border-black p-1 text-center">{parseFloat(owner.totalHectare || 0).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>

          </table></div>
        {/* </div> */}

        <div className="mt-12">
          {/* <div className="text-left mb-4">
            <p>(अजिंक्य गोडगे)</p>
          </div> */}

          <div className="flex items-end">
            <div className="ml-auto text-right">
              <p>({laoName || ''})</p>
              <p className="mb-2">{laoDesi || ''}</p>
              {/* <p>(इमारत व दळणवळण)</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (loadingRecords) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex justify-center items-center h-80">
          <div className="text-center animate-float">
            <div className="inline-flex relative">
              <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
              <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
              </div>
            </div>
            <p className="text-gray-400 mt-4">कलम 21(1)(1) लोड करत आहे...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4">
      {/* {loading && <p>Loading data...</p>} */}
      {error && <p className="text-red-600">{error}</p>}
      <div className="mb-4 flex gap-4">
        <button
          onClick={handlePrint}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition-colors"
        >
          {translations[language].Print}
        </button>

        {/* {userRole === ROLES.LAO && ( */}
        {/* Data Entry */}
        {(userRole === ROLES.LAO || userRole===ROLES.DATA_ENTRY) && (
          <button
            type="button"
            onClick={() => setShowEditModal(true)}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition-colors"
          >
            {translations[language].edit}
          </button>
        )}

        {/* <button
          onClick={() => handleSection21_1()}
          className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
          <span className="font-medium">{translations[language].Section21_1}</span>
        </button> */}


        {/* <button
          onClick={() => handleSection21_1_4()}
          className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
          <span className="font-medium">{translations[language].Section21_1_4}</span>
        </button> */}

        {/* <button
          onClick={() => handleUnderSection21()}
          className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
          <span className="font-medium">{translations[language].UnderSection21}</span>
        </button> */}

      </div>

      {/* Main Document Display */}
      <DocumentContent isEditable={false} />

      {/* Enhanced Edit Modal */}
      {showEditModal && renderEditModal()}

      {/* Print-specific styles */}
      <style jsx>{`
        @media print {
          body * {
            visibility: hidden;
            font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
          }
          
          .print-content, .print-content * {
            visibility: visible;
          }
         
          .print-content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          
           @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }

        .page {
    min-height: auto !important; /* remove screen min height */
    height: auto !important;
    page-break-after: always;
  }
table {
  border-collapse: separate !important;
  border-spacing: 0;
}

  .page:last-child {
    page-break-after: auto; /* avoid blank last page */
  }

        }
      `}</style>
    </div>
  );
}
export default RailwaySection21_1;